import { useSidebarState } from '../../hooks/useSidebarState'
import { AppSidebar } from '../AppSidebar/AppSidebar'
import { AppTopbar } from '../AppTopbar/AppTopbar'
import type { AppShellProps } from './AppShell.types'
import './AppShell.css'

export function AppShell({ children }: AppShellProps) {
  const { isCollapsed, isDrawerOpen, toggleSidebar, closeDrawer } =
    useSidebarState()
  const shellClassName = [
    'app-shell',
    isCollapsed ? 'app-shell--collapsed' : '',
    isDrawerOpen ? 'app-shell--drawer-open' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={shellClassName}>
      <a href="#main-content" className="app-shell__skip-link">
        Skip to content
      </a>
      <AppSidebar
        isCollapsed={isCollapsed}
        isDrawerOpen={isDrawerOpen}
        onNavigate={closeDrawer}
      />
      {isDrawerOpen && (
        <div
          className="app-shell__scrim"
          aria-hidden="true"
          onClick={closeDrawer}
        />
      )}
      <div className="app-shell__main">
        <AppTopbar onToggleSidebar={toggleSidebar} />
        <main id="main-content" className="app-shell__content" tabIndex={-1}>
          {children}
        </main>
      </div>
    </div>
  )
}
